import uuid from 'powtoon-commons/utils/uuid'
import {SoundLibraryItem} from 'powtoon-library/common/types'
import {ManifestUserSoundBase, ManifestAssetVoiceover} from 'powtoon-versioning/src/currentSchema'

type AvatarSoundInput = SoundLibraryItem | ManifestUserSoundBase | ManifestAssetVoiceover

function isManifestSound(sound: AvatarSoundInput): sound is ManifestUserSoundBase {
  return 'contentItemId' in sound
}

function isSoundLibraryItem(sound: AvatarSoundInput): sound is SoundLibraryItem {
  return 'assetType' in sound
}

export default function lib2AvatarAudioTrack(sound: AvatarSoundInput) {
  const {itemType, audioType} = sound

  return ({
    id: uuid(),
    contentItemId: isManifestSound(sound) ? sound.contentItemId : sound.id,
    itemType,
    audioType,
    ...(isSoundLibraryItem(sound) && {assetType: sound.assetType})
  })
}
